/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVulnerability {
    getFixupPrototypeFunction() { return AppSecopsSbomVulnerability.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVulnerability>): AppSecopsSbomVulnerability {
        let obj = Object.assign(new AppSecopsSbomVulnerability(), model);
        AppSecopsSbomVulnerability.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVulnerability>): AppSecopsSbomVulnerability {
        if (!model) return null;
        return AppSecopsSbomVulnerability.newInstance(<AppSecopsSbomVulnerability> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVulnerability) {
        if (!obj) return;

        models.AppSecopsSbomVulnerability.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVulnerability): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomVulnerability.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.overall_risk_score === undefined) {
            this.overall_risk_score = 0;
        }
        if (this.top_cvss_metric) {
            models.AppSecopsVulnerabilityCvssMetric.fixupPrototype(this.top_cvss_metric);
        }
        if (this.bom_references) {
            for (let val of this.bom_references) {
                models.AppSecopsComponentReference.fixupPrototype(val);
            }
        }
        if (this.references_from_sbom) {
            for (let val of this.references_from_sbom) {
                models.AppSecopsExternalReferenceDetail.fixupPrototype(val);
            }
        }
    }

    /**
     * List of sbom version vulnerability ID(s)
     */
    sbom_version_vulnerability_ids: Array<string>;

    /**
     * The Unique ID of the vulnerability
     */
    vulnerability_id: string;

    /**
     * Top CVSS metric of a vulnerability
     */
    top_cvss_metric: models.AppSecopsVulnerabilityCvssMetric;

    /**
     * Indicates whether the vulnerability is a Known Exploited Vulnerability (KEV)
     */
    is_kev: boolean;

    /**
     * Aggregated risk score representing the overall impact of the vulnerability, considering multiple risk factors.
     */
    overall_risk_score: number;

    /**
     * List of Bom references
     */
    bom_references: Array<models.AppSecopsComponentReference>;

    /**
     * Description of the vulnerability from the SBOM
     */
    description_from_sbom: string;

    references_from_sbom: Array<models.AppSecopsExternalReferenceDetail>;

}
